import {
  CpuChartData,
  GpuChartData,
  MemoryChartData,
  StorageChartData,
} from '../_types';
import {
  getCpuChartData,
  getGpuChartData,
  getMemoryChartData,
  getStorageChartData,
  toNumericSummary,
} from '../_utils';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { useClusterSummaryQuery } from '@cast/shared-cost-data-access';

import { useInViewport } from '@cast/shared-layout-ui';

export type UseChartsData = {
  cpu?: CpuChartData;
  memory?: MemoryChartData;
  gpu?: GpuChartData;
  storage?: StorageChartData;
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
};

export const useChartsData = (): UseChartsData => {
  const inView = useInViewport();
  const { cluster } = useCluster();
  const { summary, isLoading, error, refetch } = useClusterSummaryQuery(
    cluster.id,
    !inView
  );

  if (!summary) {
    return { isLoading, hasError: !!error, refetch };
  }

  const numericSummary = toNumericSummary(summary);

  return {
    cpu: getCpuChartData(numericSummary),
    memory: getMemoryChartData(numericSummary),
    gpu: getGpuChartData(numericSummary),
    storage: getStorageChartData(numericSummary),
    isLoading,
    hasError: !!error,
    refetch,
  };
};
